import axios from '../api/axiosSetup3';
import { ReactionToCustomer, PlateToReaction, ReactionType } from '../types/reaction';

const getReactionToCustomer = async (): Promise<ReactionToCustomer[]> => {
    const res = await axios.get<ReactionToCustomer[]>(`/reaction_type_to_customer`, {
        headers: {
            'Accept-Profile': 'public' // schema
        }        
    });
    return res.data;
};

const deleteReactionToCustomer = async (customer_id: number, reaction_type_id: number): Promise<void> => {
    await axios.delete<ReactionToCustomer>(`/reaction_type_to_customer?customer_id=eq.${customer_id}&reaction_type_id=eq.${reaction_type_id}`, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
}

const postReactionToCustomer = async (data: ReactionToCustomer): Promise<ReactionToCustomer> => {
    const res = await axios.post('/reaction_type_to_customer', data, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
    return res.status === 201 ? data : {} as ReactionToCustomer;
}

const putReactionToCustomer = async (data: ReactionToCustomer): Promise<ReactionToCustomer> => {
    const res = await axios.put<ReactionToCustomer>(`/reaction_type_to_customer?reaction_type_id=eq.${data.reaction_type_id}&customer_id=eq.${data.customer_id}`, data, {
    // const res = await axios.post('/reaction_type_to_customer', data, {
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
    return res.status === 204 ? data : {} as ReactionToCustomer;
}

const getReactionType = async ({ lang = 'en' } = {}): Promise<ReactionType[]> => {
    console.log('getReactionType lang', lang);
    
    const res = await axios.get<ReactionType[]>(`/reaction_type`, {
        headers: {
            'Accept-Profile': 'public' // schema
        },
    });
    return res.data.map(item => ({
        ...item,
        description: item.description_js?.[lang] || item.description_js?.['en'] || item.description || item.name
    }));
};

const getReactionTypes = async (): Promise<ReactionType[]> => {
    const res = await axios.get(`/reaction_type_to_customer`, {
        params: {
            select: 'id,reaction_type_id,name,param,reaction_type(name,template)'
        },
        headers: {
            'Accept-Profile': 'public' // schema
        },
    });
    const data1 = res.data.map((item: any) => ({
        ...item,
        rtname: item.reaction_type?.name,
    }));
    return data1.map((item: any) => ({
        ...item,
        name: item.rtname + (item.name ? ' / ' + item.name : ''),
    }));
};

const getReactionType__ = async ({ lang = 'en' } = {}): Promise<ReactionType[]> => {
    console.log('getReactionType lang', lang);
    
    const res = await axios.get<ReactionType[]>(`/reaction_type`, {
        headers: {
            'Accept-Profile': 'public' // schema
        },
        params: {
            select: `*,description:description_js->>${lang}`
        },
    });
    return res.data;
};

const getReactionType_ = async (): Promise<ReactionType[]> => {
    const res = await axios.get<ReactionType[]>(`/reaction_type`, {
        headers: {
            'Accept-Profile': 'public' // schema
        },
    });
    return res.data;
};

const getPlateToReaction = async (): Promise<PlateToReaction[]> => {
    const res = await axios.get<PlateToReaction[]>(`/lpr_plate_to_reaction`, );
    return res.data;
};

const deletePlateToReaction = async (plate_id: number, reaction_type_id: number): Promise<void> => {
    await axios.delete<ReactionToCustomer>(`/lpr_plate_to_reaction?plate_id=eq.${plate_id}&reaction_type_id=eq.${reaction_type_id}`, );
}

const postPlateToReaction = async (data: PlateToReaction): Promise<PlateToReaction> => {
    const res = await axios.post('/lpr_plate_to_reaction', data, );
    return res.status === 201 ? data : {} as PlateToReaction;
}

const putPlateToReaction = async (data: PlateToReaction): Promise<PlateToReaction> => {
    const res = await axios.put<PlateToReaction>(`/lpr_plate_to_reaction?reaction_type_id=eq.${data.reaction_type_id}&customer_id=eq.${data.customer_id}`, data, );
    return res.status === 204 ? data : {} as PlateToReaction;
}

/*const getLocalizedDescription = (reaction: ReactionType, lang: string = 'uk'): string => {
  // 1. Пытаемся взять текст на текущем языке
  // 2. Если нет — берем английский (fallback)
  // 3. Если и его нет — берем старое поле description или пустую строку
  return reaction.description_js?.[lang] 
    || reaction.description_js?.['en'] 
    || reaction.description 
    || '';
};*/

export const api = {
    getReactionToCustomer,
    putReactionToCustomer,
    postReactionToCustomer,
    deleteReactionToCustomer,
    
    getReactionType,
    getReactionTypes, // with customer data

    getPlateToReaction,
    putPlateToReaction,
    postPlateToReaction,
    deletePlateToReaction,
};